var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimSaudi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "claim-saudi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M14.25 1.5H3.75C2.92157 1.5 2.25 2.17157 2.25 3V14.3658C2.25 15.4047 3.28059 16.129 4.25808 15.7771L5.4294 15.3554C5.79541 15.2237 6.19829 15.2392 6.55303 15.3989L8.38445 16.223C8.77591 16.3992 9.22409 16.3992 9.61555 16.223L11.447 15.3989C11.8017 15.2392 12.2046 15.2237 12.5706 15.3554L13.7419 15.7771C14.7194 16.129 15.75 15.4047 15.75 14.3658V3C15.75 2.17157 15.0784 1.5 14.25 1.5Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1902 9.83425H11.8398V10.9146H14.25V8.45774H13.1902V9.83425Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0433 8.99997C10.0433 9.45881 9.67506 9.83422 9.22494 9.83422C8.77481 9.83422 8.40653 9.46298 8.40653 8.99997V5.25H7.34261V8.99997C7.34261 10.0553 8.18557 10.9146 9.22085 10.9146C10.2561 10.9146 11.0991 10.0553 11.0991 8.99997V8.91654H10.0433V8.99997Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5505 9.4588C5.5505 9.66736 5.38681 9.83421 5.18221 9.83421C4.9776 9.83421 4.81393 9.66736 4.81393 9.4588V8.91653H3.75V9.4588C3.75 10.2639 4.39245 10.9146 5.17812 10.9146C5.96379 10.9146 6.60623 10.2597 6.60623 9.4588V5.25416H5.5423V9.4588H5.5505Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6572 11.6655H9.59325V12.75H10.6572V11.6655Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86094 11.6655H7.79702V12.75H8.86094V11.6655Z",
    fill: "#6B47F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSaudi);
export default __webpack_public_path__ + "static/media/claim-saudi.c4917326664bc0d8ced5855bdb9b7b9d.svg";
export { ForwardRef as ReactComponent };